import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // Get register list
  getRegisterList: async ({ commit }, payload) => {
    const { limit, page, order, search, action } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/registers', {
        params: {
          limit,
          page,
          order,
          search,
          action
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'registers',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get cash drop list
  getCashDropList: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/registers/cash-drop', {
        params: {
          ...payload
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'cashDrops',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get cash float list
  getCashFloatList: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/registers/cash-float', {
        params: {
          ...payload
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'cashFloats',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get prepare user list
  getPrepareUserList: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/registers/prepare-user-list', {
        params: {
          ...payload
        }
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'prepareUserList',
        data: res.data.prepareUsers
      })

      return {
        data: res.data.prepareUsers
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get register by id
  getRegisterById: async (_, id) => {
    try {
      const res = await axios.get(`/registers/${id}`)

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get cash drop by id
  getCashDropById: async (_, id) => {
    try {
      const res = await axios.get(`/registers/cash-drop/${id}`)

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get cash float by id
  getCashFloatById: async (_, id) => {
    try {
      const res = await axios.get(`/registers/cash-float/${id}`)

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add register
  insert: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/registers', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add cash drop
  addCashDrop: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/registers/cash-drop', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add cash float
  addCashFloat: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/registers/cash-float', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update register
  updateRegister: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`registers/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update cash drop
  updateCashDrop: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`registers/cash-drop/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update cash float
  updateCashFloat: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`registers/cash-float/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // delete register
  deleteRegister: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await await axios.delete(`/registers/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // delete cash drop
  deleteCashDrop: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await await axios.delete(`/registers/cash-drop/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // delete cash float
  deleteCashFloat: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await await axios.delete(`/registers/cash-float/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}
